import React from 'react';
import { IonPopover, IonList, IonItem, IonLabel } from '@ionic/react';

interface PopoverMenuItem {
  key: string;
  value: string;
}

interface PopoverMenuComponentProps {
  isOpen: boolean;
  event?: Event;
  alignment?: 'start' | 'center' | 'end';
  onDismiss: (selectedKey?: string) => void;
  menuItems: PopoverMenuItem[];
}

export const PopoverMenuComponent: React.FC<PopoverMenuComponentProps> = ({
  isOpen,
  event,
  alignment,
  onDismiss,
  menuItems
}) => {
  const handleItemClick = (key: string) => {
    onDismiss(key);
  };

  return (
    <IonPopover
      mode="ios"
      isOpen={isOpen}
      event={event}
      onDidDismiss={() => onDismiss()}
      className="popover-menu-default"
      alignment={alignment}
    >
      <IonList>
        {menuItems.map((item, index) => (
          <IonItem
            detail={false}
            lines={index < menuItems.length - 1 ? 'inset' : 'none'}
            key={item.key}
            button
            onClick={() => handleItemClick(item.key)}
          >
            <IonLabel>{item.value}</IonLabel>
          </IonItem>
        ))}
      </IonList>
    </IonPopover>
  );
};
